// Carrousel mobile (bloc logiciels) : synchronise l'indicateur de points avec le
// défilement, et permet de cliquer un point pour aller à la carte. Le défilement
// lui-même est géré en CSS (scroll-snap) ; ce module n'est qu'un enrichissement.
export function initCarousel() {
  document.querySelectorAll("[data-carousel-dots]").forEach((dotsWrap) => {
    const track = dotsWrap.previousElementSibling; // <ul class="c-products">
    if (!track) return;
    const cards = [...track.children];
    const dots = [...dotsWrap.children];
    if (cards.length !== dots.length || !dots.length) return;

    const setActive = (i) => {
      dots.forEach((d, j) =>
        d.setAttribute("aria-current", j === i ? "true" : "false"),
      );
    };

    // Clic d'un point → défile jusqu'à la carte correspondante
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
    dots.forEach((dot, i) => {
      dot.addEventListener("click", () => {
        cards[i].scrollIntoView({
          behavior: reduce.matches ? "auto" : "smooth",
          inline: "start",
          block: "nearest",
        });
      });
    });

    // La carte la plus visible dans le track devient active
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && e.intersectionRatio >= 0.6) {
            setActive(cards.indexOf(e.target));
          }
        });
      },
      { root: track, threshold: [0.6] },
    );
    cards.forEach((c) => io.observe(c));
  });
}
